import angular from 'angular';
import _ from 'lodash';

(function () {
  'use strict';
  angular.module('app.principal').factory('InvoiceParamSvc', InvoiceParamSvc);

  InvoiceParamSvc.$inject = ['$q', 'INVOICE_PARAM', 'InvoiceTemplateAttribute', 'InvoiceTemplateDA'];

  /* @ngInject */
  function InvoiceParamSvc($q, INVOICE_PARAM, InvoiceTemplateAttribute, InvoiceTemplateDA) {
    var exports = {
      saveInvoiceTemplate: saveInvoiceTemplate,
      filterDataModal: filterDataModal,
      findDoublons: findDoublons,
      addAttributesToSection: addAttributesToSection
    };

    return exports;

    ////////////////

    /**
     * Enregistrement du template de la facture
     */
    function saveInvoiceTemplate(principalEid, invoiceTemplateInfo, invoiceAttributes, controlSets, legibleFile, selectedBusinessModel, selectedControlSet, selectedBusinessModel_FactureX, selectedEligibilityEnrichmentSet) {
      var deferred = $q.defer();
      stageLegible(principalEid, legibleFile).then(
        function (legibleFileId) {
          InvoiceTemplateDA.saveInvoiceTemplate(
            principalEid,
            _prepInvTempBeforeSave(invoiceTemplateInfo, invoiceAttributes, controlSets, legibleFileId, selectedBusinessModel, selectedControlSet, selectedBusinessModel_FactureX, selectedEligibilityEnrichmentSet)
          ).then(
            function (saveResult) {
              let result = { result: saveResult, legibleFileId: legibleFileId }
              deferred.resolve(result);
            },
            function (error) {
              deferred.reject(error);
            }
          );
        },
        function (error) {
          deferred.reject(error);
        }
      );
      return deferred.promise;
    }

    function stageLegible(principalEid, legibleFile) {
      var deferred = $q.defer();
      if (legibleFile) {
        InvoiceTemplateDA.stageLegible(principalEid, legibleFile).then(
          function (resp) {
            deferred.resolve(resp.data);
          },
          function (error) {
            deferred.reject(error);
          }
        );
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    /**
     * Remet le bon indice (order) pour chaque attribut avant d'envoyer la facture
     */
    function _prepInvTempBeforeSave(invoiceTemplateInfo, invoiceAttributes, controlSets, legibleFileId, selectedBusinessModel, selectedControlSetReform, selectedBusinessModel_FactureX, selectedEligibilityEnrichmentSet) {
      //        	var concatData = [];
      //        	for(var key in invoiceAttributes) {
      //        		_addOrder(invoiceAttributes[key]);
      //        		concatData = concatData.concat(invoiceAttributes[key])
      //        	}
        invoiceTemplateInfo.invoiceTemplate.attributes = _concatData(invoiceAttributes, true);
        //recuperer les sets control selectionnés
        var selectedControlSets = concatSelectedControlSet(controlSets);
        return {
            invoiceTemplateParams: {
                invoiceTemplateInfo: invoiceTemplateInfo,
                controlSets: selectedControlSets,
                businessModelReform: selectedBusinessModel,
                controlSetReform: selectedControlSetReform,
                businessModelFactureX: selectedBusinessModel_FactureX,
                eligibilityEnrichmentSet: selectedEligibilityEnrichmentSet
            }, legibleFileId: legibleFileId
        };
    }

    /**
     * Concatenation des sets de control selectionés.
     * @param {} controlSets
     */
    function concatSelectedControlSet(controlSets) {
      var concatedSelected = [];
      for (var key in controlSets) {
        var selected = _.filter(controlSets[key], 'selected');
        concatedSelected = concatedSelected.concat(selected);
      }
      return concatedSelected;
    }

    /**
     * Cocaténation des données au format :
     * {
     * 		seller: [Atribute, Attribute],
     * 		buyer: [Atribute, Attribute],
     * 		...
     * }
     * en
     * [Atribute, Attribute, Atribute, Attribute,...]
     */
    function _concatData(invoiceAttributes, addOrder) {
      var concatData = [];
      for (var key in invoiceAttributes) {
        var attributes = invoiceAttributes[key];
        if (addOrder) {
          _addOrder(attributes);
        }
        concatData = concatData.concat(attributes);
      }
      return concatData;
    }

    /**
     * Ajout de l'ordre pour les attributs d'une section non standard (triables)
     */
    function _addOrder(sectionAttributes) {
      var standardAttrs = _.filter(sectionAttributes, function (stdAttr) {
        return stdAttr.isStandard();
      });
      var maxOrder = _.maxBy(standardAttrs, 'order');
      maxOrder = maxOrder ? maxOrder.order : 0;
      var length = sectionAttributes.length;
      for (var idx = 0; idx < length; idx++) {
        var attr = sectionAttributes[idx];
        if (!attr.isStandard()) {
          maxOrder++;
          attr.order = maxOrder;
        }
      }
    }

    /**
     * Retourne les données de la liste des champs disponible dans la pop-up d'ajout d'un champ
     *
     * @param {LegalEntity[]} buyersList - Liste totale des clients
     *
     * @param {InvoiceTemplateAttribute[]} attributes - Liste des attri buts disponible pour ce DO
     * @param {InvoiceTemplate[]} invoiceTemplateAttributes - Liste des attributs déjà présent dans la facture
     * @param {string} sectionType - Saction dans laquelle on souhaite ajouter une données
     *
     * @return InvoiceTemplateAttribute[] liste d'attributs disponible pour cette catégorie et non utilisés
     */
    function filterDataModal(attributes, invoiceTemplateAttributes, sectionType) {
      // Le invoiceTemplateAttributes est trié par section, il faut supprimer cette arborescence pour obtenir
      // une liste de touts les attributs déjà présent dans la facture
      var invoiceAttributes = _concatData(invoiceTemplateAttributes, false);
      // On filtre déjà tous les attributs déjà présent dans la facture
      var filteredAttributes = _.differenceBy(attributes, invoiceAttributes, 'path');
      // Puis on ne prend que les attributs autorisé pour la section dans laquelle
      // on souhaite ajouter l'attribut
      return _.filter(filteredAttributes, function (a) {
        return INVOICE_PARAM.sectionsCategories[sectionType].indexOf(a.category) !== -1;
      });
    }

    /**
     * Repère les doublons dans une liste, en indiquant quel attribut doit etre comparé, et
     * le nom de l'erreur à rajouter pour l'objet doublon
     *
     * @param {array} attributes - liste des objets à comparer
     * @param {string} col - Nom de l'attribut à comparer
     * @param {string} error - Nom de l'erreur
     *
     * @return true si au moins un doublon a été detecté
     */
    function findDoublons(attributes, col, error) {
      var existingAtt = [];
      var attLength = attributes.length;
      var hasDoublon = false;
      for (var idx = 0; idx < attLength; idx++) {
        var attribute = attributes[idx];
        if (attribute[col] && existingAtt.indexOf(attribute[col]) !== -1) {
          hasDoublon = true;
          attribute.error = {};
          attribute.error[error] = true;
        } else if (attribute[col]) {
          existingAtt.push(attribute[col]);
        }
      }
      return hasDoublon;
    }

    /**
     * Permet d'ajouter une liste d'attributs dans une section.
     * Si l'attribut à ajouter a un ordre, on l'insere comme il faut
     * Si l'attribut n'a pas d'ordre défini (==-1), on l'ajoute en fin de section.
     */
    function addAttributesToSection(sectionAttrs, addedAttributes) {
      for (var i = 0; i < addedAttributes.length; i++) {
        var addedAttr = addedAttributes[i];
        if (addedAttr.order !== -1) {
          var insertedIndex = _.sortedIndexBy(sectionAttrs, addedAttr, 'order');
          sectionAttrs.splice(insertedIndex, 0, addedAttr);
        } else {
          sectionAttrs.push(addedAttr);
        }
      }
    }
  }
})();
